import React, { useRef } from 'react';
import { OptionListProvider } from './useOptionList';
export const OptionListInit = ({ children, defaultValue, value, onInit, }) => {
    const hasInit = useRef(false);
    const currentValue = value !== null && value !== void 0 ? value : defaultValue;
    return (React.createElement(OptionListProvider, { value: {
            value: currentValue,
            initialize(option, value) {
                if (hasInit.current)
                    return;
                if (!currentValue || value === currentValue) {
                    hasInit.current = true;
                    onInit({ option, value });
                }
            },
            select: noop,
        } },
        React.createElement("div", { style: { display: 'none' } }, children)));
};
const noop = () => void 0;
//# sourceMappingURL=options-list-init.js.map